module.exports = __webpack_public_path__ + "media/images/landkit/screenshots/landkit/landing/jobs-1a437589607eaf04acf0f389dcb6c145.jpg";